import PickModalClass from "./PickModalClass";
import Util from "../../libs/util/Util";
import CalenderBaseClass from "./CalenderBaseClass";
import dayjs from "dayjs";

/**
 * カレンダー　モーダルクラス
 */
export default class CalenderModalClass extends PickModalClass{
    constructor(_id,_parent){
        super(_id,_parent);

        this.TYPE_ACTIVE = "active";
        this.TYPE_MIDDLE = "middle";
        this.CL_CALENDER_MODAL_OPEN = "isCalenderModalOpen";
        this.CL_DISABLE = "disable";
        this.CL_PINK = "pink";

        this.EVENT_DATE_SAVE = "eventDateSave";

        this.DEFAULT_DATE = {
            point1:0,
            point2:1
        };

        this.name = "CalenderModalClass";

        this.onClickDaysListener = this.onClickDays.bind(this);
        this.onRollOverDaysListener = this.onRollOverDays.bind(this);
        this.onRollOutDaysListener = this.onRollOutDays.bind(this);

        this.isPoint1 = false;
        this.isPoint2 = false;

        this.nextData = {
            point1:null,
            point2:null
        };

        this.isOneWay = false;
        this.tmpRipple = null;

        this.isClickBack = false;
    }

    onCreate() {
        super.onCreate();

        this.data = {
            point1:this.DEFAULT_DATE.point1,
            point2:this.DEFAULT_DATE.point2
        };

        this.things.calender = new CalenderBaseClass(this.modal);
        this.things.calender.isSlide = (!Util.isBreakpoint);
        this.things.calender.onCreate();

        this.$btnPositive = $(".positive",this.modal);

        this.$nowSelected = $(".now_selected",this.modal);
        
        this.boxGo = $('[data-type="going"]',this.clickTarget);
        this.boxBack = $('[data-type="back"]',this.clickTarget);
    }

    onClickModalToggle(e){
        super.onClickModalToggle(e);
        const type = $(e.currentTarget).attr("data-type");
        this.isClickBack = (type === "back");
        //console.log(this.name,"onClickModalToggle",type,this.isClickBack);
    }

    onResize(_size) {
        for(let k in this.things) this.things[k].onResize(_size);
        if(Util.isBreakpoint) return;

        let offset = this.clickTarget.not(":hidden").offset();
        const parentOffset = $(this.parent).offset();
        let position;
        if(!offset) {
            let top = (_size.h - this.modal.height()) / 2;
            top += Util.getScrollY();
            position = {top:top};
        } else {
            position = {top:offset.top - parentOffset.top};
        }
        position.left = 0;//offset.left - parentOffset.left;

        this.modal.css(position);

        if(this.tmpRipple){
            this.tmpRipple.onResize(_size);
        }
    }

    onClear(){
        //console.log("onClear",this.things.calender);
        this.things.calender.onClear();
        if(this.$days){
            this.$days.off("mouseover",this.onRollOverDaysListener);
            this.$days.off("mouseout",this.onRollOutDaysListener);
            this.$days = null;
        }
    }

    /**
     * カレンダーを選択
     * @param _date:{going:dayjs or String,back:dayjs or String}
     */
    onSetDate(_date){
        //console.log(this.name,"onSetDate",_date);
        this.onReset();

        let going = (typeof _date.going == "string")? dayjs(_date.going) : _date.going;
        let back = (typeof _date.back == "string")? dayjs(_date.back) : _date.back;

        const format = 'YYYY/MM/DD';
        const goingText = going.format(format);
        const backText = back.format(format);
        //console.log(goingText,backText);

        let point1Index = this.$days.index(this.$days.filter('[data-date="'+goingText+'"]'));
        let point2Index = this.$days.index(this.$days.filter('[data-date="'+backText+'"]'));

        if(point1Index === -1) point1Index = 0;
        if(point2Index === -1) point2Index = point1Index + 1;

        this.onSetPoint1(point1Index);
        if(!this.isOneWay) this.onSetPoint2(point2Index);

        this.onPositive();
        this.onSlideMove();
    }

    /**
     * カレンダーの表示範囲を設定
     * @param _data:{calender_start:dayjs or String,calender_end:dayjs or String}
     */
    onSetData(_data){

        this.things.calender.onSetData(_data);

        this.$days = $(".wrap .box ul li a",this.modal);
        this.$days.on("click",this.onClickDaysListener);

        this.$days.on("mouseover",this.onRollOverDaysListener);
        this.$days.on("mouseout",this.onRollOutDaysListener);

        this.onSetPoint1(this.data.point1);
        this.onSetPoint2(this.data.point2);
    }

    onSetPrice(_data){
        //console.log(this.name,"onSetPrice",_data);
        this.things.calender.onSetPrice(_data);
    }

    onOpenBefore() {
        super.onOpenBefore();
        $(this.parent).addClass(this.CL_CALENDER_MODAL_OPEN);
    }

    onCloseAfter() {
        super.onCloseAfter();
        $(this.parent).removeClass(this.CL_CALENDER_MODAL_OPEN);
        if(!Util.isBreakpoint) {
            this.onSlideMove();
        }
    }

    onPositive(){
        //console.log(this.name,"onPositive");
        this.onDataSave(true);
    }

    onEventCloseBefore(){
        let flag = false;
        if(this.isOneWay){
            if(this.nextData.point1 === null) flag = false;
        } else {
            if(this.nextData.point2 === null) flag = false;
        }
        this.onDataSave(flag);
    }

    onNegativeBefore(){
        //console.log(this.name,"onNegativeBefore",this.isOneWay);
        let flag = false;
        if(this.isOneWay){
            if(this.nextData.point1 === null) flag = false;
        } else {
            if(this.nextData.point2 === null) flag = false;
        }
        this.onDataSave(flag);
    }

    onDataSave(_flag){
        if(_flag){
            this.data.point1 = this.nextData.point1;
            this.data.point2 = this.nextData.point2;
        } else {
            this.onReset();
            this.onSetPoint1(this.data.point1);
            if(!this.isOneWay){
                this.onSetPoint2(this.data.point2);
            }
        }

        this.jq.trigger(this.EVENT_DATE_SAVE);
    }

    onClickDays(e){
        e.preventDefault();
        let index = this.$days.index($(e.currentTarget));
        if(!this.isPoint1 && !this.isClickBack){
            this.onSetPoint1(index);
        } else if(!this.isPoint2 && !this.isOneWay) {
            this.onSetPoint2(index);
        } else if(this.isClickBack){
            this.onResetMiddle();
            if(this.nextData.point1 !== this.nextData.point2) this.$days.eq(this.nextData.point2).attr({"data-type":""});
            this.onSetPoint2(index);
        } else {
            this.onReset();
            this.onSetPoint1(index);
        }
    }

    onRollOverDays(e){
        e.preventDefault();
        if(!this.isPoint1 || this.isPoint2 || this.isOneWay) return;
        let index = this.$days.index($(e.currentTarget));
        this.onResetMiddle();
        this.onSetMiddle(index);
    }

    onRollOutDays(e){
        e.preventDefault();
        if(!this.isPoint1 || this.isPoint2 || this.isOneWay) return;
        this.onResetMiddle();
    }

    onReset(){
        this.isPoint1 = false;
        this.isPoint2 = false;

        this.$days.attr({"data-type":""});
        this.nextData.point1 = null;
        this.nextData.point2 = null;

        $(".text",this.boxGo).text(this.$days.eq(this.data.point1).attr("data-date"));
        $(".text",this.boxBack).text(this.$days.eq(this.data.point2).attr("data-date"));

        this.$btnPositive.removeClass(this.CL_PINK).addClass(this.CL_DISABLE);
    }

    onSetPoint1(_index){
        this.isPoint1 = true;
        this.nextData.point1 = _index;
        this.$days.eq(_index).attr({"data-type":this.TYPE_ACTIVE});

        const point1Txt = this.$days.eq(this.nextData.point1).attr("data-date")
        $(".text",this.boxGo).text(point1Txt);
        $(".going",this.$nowSelected).text(point1Txt);

        if(this.isOneWay) this.$btnPositive.removeClass(this.CL_DISABLE).addClass(this.CL_PINK);
    }

    onSetPoint2(_index){
        this.isPoint2 = true;
        this.nextData.point2 = _index;
        this.$days.eq(_index).attr({"data-type":this.TYPE_ACTIVE});
        this.onSetMiddle(_index);
        this.onSetBtnText();

        this.$btnPositive.removeClass(this.CL_DISABLE).addClass(this.CL_PINK);
    }

    onSetMiddle(_index){
        const pos = this.getPosition(_index);
        this.$days.slice(pos.start+1,pos.end).attr({"data-type":this.TYPE_MIDDLE});
    }

    onResetMiddle(){
        this.$days.filter('[data-type='+this.TYPE_MIDDLE+']').attr({"data-type":""});
    }

    onSetBtnText(){
        const pos = this.getPosition();
        const going = this.$days.eq(pos.start).attr("data-date");
        const back = this.$days.eq(pos.end).attr("data-date");
        $(".text",this.boxGo).text(going);
        $(".text",this.boxBack).text(back);
        $(".going",this.$nowSelected).text(going);
        $(".back",this.$nowSelected).text(back);
    }

    setOneWay(_b){
        this.isOneWay = _b;
        if(this.$days) {
            this.onReset();

            this.data = {
                point1:this.DEFAULT_DATE.point1,
                point2:this.DEFAULT_DATE.point2
            };
            this.onSetPoint1(this.data.point1);
            if(!this.isOneWay) this.onSetPoint2(this.data.point2);
        }

        if(this.isOneWay){
            $(".back",this.$nowSelected).css({display:"none"});
        } else {
            $(".back",this.$nowSelected).css({display:""});
        }

    }

    onSlideMove(){
        if(this.things.calender.isSlide){
            this.things.calender.onSlideMove(this.data.point1);
        }
    }

    getPosition(_index){
        let start = this.nextData.point1;
        let end = (_index != null)? _index : this.nextData.point2;
        if(start > end){
            start = (_index != null)? _index : this.nextData.point2;
            end = this.nextData.point1;
        }
        return {start:start,end:end};
    }

    getData(){
        //console.log(this.name,this.data);

        let going = "";
        let back = "";
        if(this.data){
            let start = this.data.point1;
            let end = this.data.point2;
            if(start != null && end != null){
                if(start <= end){
                    going = this.$days.eq(start).attr("data-date");
                    back = this.$days.eq(end).attr("data-date");
                } else {
                    going = this.$days.eq(end).attr("data-date");
                    back = this.$days.eq(start).attr("data-date");
                }
            } else if(start != null){
                going = this.$days.eq(start).attr("data-date");
                back = this.$days.eq(start).attr("data-date");
            } else if(end != null){
                going = this.$days.eq(end).attr("data-date");
                back = this.$days.eq(end).attr("data-date");
            }
        }
        //onsole.log(this.name,"getData",from,to);

        //let from = $(".text",this.boxGo).text();
        //let to = $(".text",this.boxBack).text();
        going = going.replace(/\//g,"");
        back = back.replace(/\//g,"");
        return {going:going,back:back};
    }
}